module.exports = __webpack_public_path__ + "img/logo-7.0eca21a9.png";